import { render } from "./CaseManagementDialog.vue?vue&type=template&id=22534172&ts=true"
import script from "./CaseManagementDialog.vue?vue&type=script&lang=ts"
export * from "./CaseManagementDialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__